import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumberInput_pointFont } from "../../../../../Components";
import {
  updateLayoutFontStyleState,
  saveFontStyle,
} from "../../../../../Redux/actions/projectActions";
import { scheduleProjectSave } from "../../../projectSaveCoordinator";

const LineHeight = ({
  styleKey,
  syncKeys = [],
  currentBlockType,
  currentBlockId,
  currentBlockIdx,
  isCard,
}) => {
  const dispatch = useDispatch();
  const fontStyle = useSelector((state) => state?.project?.fontStyle ?? {});
  const projectId = useSelector((state) => state?.project?._id);
  const value = fontStyle?.[styleKey]?.lineHeight ?? 1;
  const extraKeys = Array.isArray(syncKeys) ? syncKeys.join(",") : "";

  const onChange = useCallback(
    (val) => {
      const num = parseFloat(val);
      if (Number.isNaN(num)) return;
      const clamped = Math.min(Math.max(num, 0.8), 5.0);
      const keys = extraKeys ? [styleKey, ...extraKeys.split(",")] : [styleKey];
      dispatch(
        updateLayoutFontStyleState(
          currentBlockId,
          currentBlockIdx,
          keys.map((key) => ({
            styleKey: key,
            property: "lineHeight",
            value: clamped,
          })),
          `line-height:${keys.join(",")}`,
        ),
      );
      keys.forEach((key) => {
        scheduleProjectSave(
          `font-style-debounce:${projectId}:${key}`,
          () =>
            dispatch(
              saveFontStyle(
                key,
                currentBlockType,
                "lineHeight",
                clamped,
                null,
                isCard,
                {
                  projectId,
                  isCard,
                  fontStyle: {
                    ...(fontStyle?.[key] || {}),
                    lineHeight: clamped,
                  },
                  optimistic: true,
                },
              ),
            ),
          1000,
        );
      });
    },
    [
      dispatch,
      styleKey,
      extraKeys,
      currentBlockType,
      currentBlockId,
      currentBlockIdx,
      isCard,
      projectId,
      fontStyle,
    ],
  );

  return (
    <NumberInput_pointFont
      step="0.10"
      min="0.80"
      max="5.0"
      comp="lineHeight"
      value={value}
      onChange={onChange}
    />
  );
};

export default LineHeight;
